{
  "megastonei": {
    "name": "Mega Stone I",
    "num": 40001,
    "desc": "Use this to Mega Evolve ANY Pokemon BESIDES:\nGyarados, Tyranitar, Aggron, Steelix, Salamence, the Lati\n Twins, Metagross, Garchomp, Diancie, Charizard, & Kyurem.",
    "shortDesc": ""
  },
  "megastoneii": {
    "name": "Mega Stone II",
    "num": 40002,
    "desc": "Use this to Mega Evolve Gyarados, Tyranitar,\nSteelix, Salamence, Metagross, Garchomp & Diancie.\nUse Megastone I for other Pokemon.",
    "shortDesc": ""
  },
  "abilityshield": {
    "name": "Ability Shield",
    "num": 1881,
    "desc": "Holder's Ability cannot be changed by any effect.",
    "shortDesc": ""
  },
  "abomasite": {
    "name": "Abomasite",
    "num": 674,
    "desc": "If held by an Abomasnow, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "absolite": {
    "name": "Absolite",
    "num": 677,
    "desc": "If held by an Absol, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "absorbbulb": {
    "name": "Absorb Bulb",
    "num": 545,
    "desc": "Raises holder's Sp. Atk by 1 stage if hit by a Water-type attack. Single use.",
    "shortDesc": ""
  },
  "adamantcrystal": {
    "name": "Adamant Crystal",
    "num": 1777,
    "desc": "If held by a Dialga, its Steel- and Dragon-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "adamantorb": {
    "name": "Adamant Orb",
    "num": 135,
    "desc": "If held by a Dialga, its Steel- and Dragon-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "adrenalineorb": {
    "name": "Adrenaline Orb",
    "num": 846,
    "desc": "Raises holder's Speed by 1 stage if it gets affected by Intimidate. Single use.",
    "shortDesc": ""
  },
  "aerodactylite": {
    "name": "Aerodactylite",
    "num": 672,
    "desc": "If held by an Aerodactyl, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "aggronite": {
    "name": "Aggronite",
    "num": 667,
    "desc": "If held by an Aggron, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "aguavberry": {
    "name": "Aguav Berry",
    "num": 162,
    "desc": "Restores 1/3 max HP at 1/4 max HP or less; confuses if -SpD Nature. Single use.",
    "shortDesc": ""
  },
  "airballoon": {
    "name": "Air Balloon",
    "num": 541,
    "desc": "Holder is immune to Ground-type attacks. Pops when holder is hit.",
    "shortDesc": ""
  },
  "alakazite": {
    "name": "Alakazite",
    "num": 679,
    "desc": "If held by an Alakazam, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "aloraichiumz": {
    "name": "Aloraichium Z",
    "num": 803,
    "desc": "If held by an Alolan Raichu with Thunderbolt, it can use Stoked Sparksurfer.",
    "shortDesc": ""
  },
  "altarianite": {
    "name": "Altarianite",
    "num": 755,
    "desc": "If held by an Altaria, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "ampharosite": {
    "name": "Ampharosite",
    "num": 658,
    "desc": "If held by an Ampharos, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "apicotberry": {
    "name": "Apicot Berry",
    "num": 205,
    "desc": "Raises holder's Sp. Def by 1 stage when at 1/4 max HP or less. Single use.",
    "shortDesc": ""
  },
  "armorfossil": {
    "name": "Armor Fossil",
    "num": 104,
    "desc": "Can be revived into Shieldon.",
    "shortDesc": ""
  },
  "aspearberry": {
    "name": "Aspear Berry",
    "num": 153,
    "desc": "Holder is cured if it is frozen. Single use.",
    "shortDesc": ""
  },
  "assaultvest": {
    "name": "Assault Vest",
    "num": 640,
    "desc": "Holder's Sp. Def is 1.5x, but it can only select damaging moves.",
    "shortDesc": ""
  },
  "audinite": {
    "name": "Audinite",
    "num": 757,
    "desc": "If held by an Audino, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "auspiciousarmor": {
    "name": "Auspicious Armor",
    "num": 2344,
    "desc": "Evolves Charcadet into Armarouge when used.",
    "shortDesc": ""
  },
  "babiriberry": {
    "name": "Babiri Berry",
    "num": 199,
    "desc": "Halves damage taken from a supereffective Steel-type attack. Single use.",
    "shortDesc": ""
  },
  "banettite": {
    "name": "Banettite",
    "num": 668,
    "desc": "If held by a Banette, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "beastball": {
    "name": "Beast Ball",
    "num": 851,
    "desc": "A special Poke Ball designed to catch Ultra Beasts.",
    "shortDesc": ""
  },
  "beedrillite": {
    "name": "Beedrillite",
    "num": 770,
    "desc": "If held by a Beedrill, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "belueberry": {
    "name": "Belue Berry",
    "num": 183,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "berryjuice": {
    "name": "Berry Juice",
    "num": 43,
    "desc": "Restores 20 HP when at 1/2 max HP or less. Single use.",
    "shortDesc": ""
  },
  "berrysweet": {
    "name": "Berry Sweet",
    "num": 1111,
    "desc": "Evolves Milcery into Alcremie when held and spun around.",
    "shortDesc": ""
  },
  "bignugget": {
    "name": "Big Nugget",
    "num": 581,
    "desc": "A big nugget of pure gold that gives off a lustrous gleam.",
    "shortDesc": ""
  },
  "bigroot": {
    "name": "Big Root",
    "num": 296,
    "desc": "Holder gains 1.3x HP from draining/Aqua Ring/Ingrain/Leech Seed/Strength Sap.",
    "shortDesc": ""
  },
  "bindingband": {
    "name": "Binding Band",
    "num": 544,
    "desc": "Holder's partial-trapping moves deal 1/6 max HP per turn instead of 1/8.",
    "shortDesc": ""
  },
  "blackbelt": {
    "name": "Black Belt",
    "num": 241,
    "desc": "Holder's Fighting-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "blackglasses": {
    "name": "Black Glasses",
    "num": 240,
    "desc": "Holder's Dark-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "blacksludge": {
    "name": "Black Sludge",
    "num": 281,
    "desc": "Each turn, if holder is a Poison type, restores 1/16 max HP; loses 1/8 if not.",
    "shortDesc": ""
  },
  "blastoisinite": {
    "name": "Blastoisinite",
    "num": 661,
    "desc": "If held by a Blastoise, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "blazikenite": {
    "name": "Blazikenite",
    "num": 664,
    "desc": "If held by a Blaziken, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "blueorb": {
    "name": "Blue Orb",
    "num": 535,
    "desc": "If held by a Kyogre, this item triggers its Primal Reversion in battle.",
    "shortDesc": ""
  },
  "blukberry": {
    "name": "Bluk Berry",
    "num": 165,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "blunderpolicy": {
    "name": "Blunder Policy",
    "num": 1121,
    "desc": "If the holder misses due to accuracy, its Speed is raised by 2 stages. Single use.",
    "shortDesc": ""
  },
  "boosterenergy": {
    "name": "Booster Energy",
    "num": 1880,
    "desc": "Activates the Protosynthesis or Quark Drive Abilities. Single use.",
    "shortDesc": ""
  },
  "bottlecap": {
    "name": "Bottle Cap",
    "num": 795,
    "desc": "Used for Hyper Training. One of a Pokemon's stats is calculated with an IV of 31.",
    "shortDesc": ""
  },
  "brightpowder": {
    "name": "Bright Powder",
    "num": 213,
    "desc": "The accuracy of attacks against the holder is 0.9x.",
    "shortDesc": ""
  },
  "buggem": {
    "name": "Bug Gem",
    "num": 558,
    "desc": "Holder's first successful Bug-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "bugmemory": {
    "name": "Bug Memory",
    "num": 909,
    "desc": "Holder's Multi-Attack is Bug type.",
    "shortDesc": ""
  },
  "buginiumz": {
    "name": "Buginium Z",
    "num": 787,
    "desc": "If holder has a Bug move, this item allows it to use a Bug Z-Move.",
    "shortDesc": ""
  },
  "burndrive": {
    "name": "Burn Drive",
    "num": 118,
    "desc": "Holder's Techno Blast is Fire type.",
    "shortDesc": ""
  },
  "cameruptite": {
    "name": "Cameruptite",
    "num": 767,
    "desc": "If held by a Camerupt, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "cellbattery": {
    "name": "Cell Battery",
    "num": 546,
    "desc": "Raises holder's Attack by 1 if hit by an Electric-type attack. Single use.",
    "shortDesc": ""
  },
  "charcoal": {
    "name": "Charcoal",
    "num": 249,
    "desc": "Holder's Fire-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "charizarditex": {
    "name": "Charizardite X",
    "num": 660,
    "desc": "If held by a Charizard, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "charizarditey": {
    "name": "Charizardite Y",
    "num": 678,
    "desc": "If held by a Charizard, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "chartiberry": {
    "name": "Charti Berry",
    "num": 195,
    "desc": "Halves damage taken from a supereffective Rock-type attack. Single use.",
    "shortDesc": ""
  },
  "cheriberry": {
    "name": "Cheri Berry",
    "num": 149,
    "desc": "Holder cures itself if it is paralyzed. Single use.",
    "shortDesc": ""
  },
  "chestoberry": {
    "name": "Chesto Berry",
    "num": 150,
    "desc": "Holder wakes up if it is asleep. Single use.",
    "shortDesc": ""
  },
  "chilanberry": {
    "name": "Chilan Berry",
    "num": 200,
    "desc": "Halves damage taken from a Normal-type attack. Single use.",
    "shortDesc": ""
  },
  "chilldrive": {
    "name": "Chill Drive",
    "num": 119,
    "desc": "Holder's Techno Blast is Ice type.",
    "shortDesc": ""
  },
  "chippedpot": {
    "name": "Chipped Pot",
    "num": 1254,
    "desc": "Evolves Sinistea-Antique into Polteageist-Antique when used.",
    "shortDesc": ""
  },
  "choiceband": {
    "name": "Choice Band",
    "num": 220,
    "desc": "Holder's Attack is 1.5x, but it can only select the first move it executes.",
    "shortDesc": ""
  },
  "choicescarf": {
    "name": "Choice Scarf",
    "num": 287,
    "desc": "Holder's Speed is 1.5x, but it can only select the first move it executes.",
    "shortDesc": ""
  },
  "choicespecs": {
    "name": "Choice Specs",
    "num": 297,
    "desc": "Holder's Sp. Atk is 1.5x, but it can only select the first move it executes.",
    "shortDesc": ""
  },
  "chopleberry": {
    "name": "Chople Berry",
    "num": 189,
    "desc": "Halves damage taken from a supereffective Fighting-type attack. Single use.",
    "shortDesc": ""
  },
  "clawfossil": {
    "name": "Claw Fossil",
    "num": 100,
    "desc": "Can be revived into Anorith.",
    "shortDesc": ""
  },
  "clearamulet": {
    "name": "Clear Amulet",
    "num": 1882,
    "desc": "Prevents other Pokemon from lowering the holder's stat stages.",
    "shortDesc": ""
  },
  "cloversweet": {
    "name": "Clover Sweet",
    "num": 1112,
    "desc": "Evolves Milcery into Alcremie when held and spun around.",
    "shortDesc": ""
  },
  "cobaberry": {
    "name": "Coba Berry",
    "num": 192,
    "desc": "Halves damage taken from a supereffective Flying-type attack. Single use.",
    "shortDesc": ""
  },
  "colburberry": {
    "name": "Colbur Berry",
    "num": 198,
    "desc": "Halves damage taken from a supereffective Dark-type attack. Single use.",
    "shortDesc": ""
  },
  "cornerstonemask": {
    "name": "Cornerstone Mask",
    "num": 2406,
    "desc": "Ogerpon-Cornerstone: 1.2x power attacks; Terastallize to gain Embody Aspect.",
    "shortDesc": ""
  },
  "cornnberry": {
    "name": "Cornn Berry",
    "num": 175,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "coverfossil": {
    "name": "Cover Fossil",
    "num": 572,
    "desc": "Can be revived into Tirtouga.",
    "shortDesc": ""
  },
  "covertcloak": {
    "name": "Covert Cloak",
    "num": 1885,
    "desc": "Holder is not affected by the secondary effect of another Pokemon's attack.",
    "shortDesc": ""
  },
  "crackedpot": {
    "name": "Cracked Pot",
    "num": 1253,
    "desc": "Evolves Sinistea into Polteageist when used.",
    "shortDesc": ""
  },
  "custapberry": {
    "name": "Custap Berry",
    "num": 210,
    "desc": "Holder moves first in its priority bracket when at 1/4 max HP or less. Single use.",
    "shortDesc": ""
  },
  "damprock": {
    "name": "Damp Rock",
    "num": 285,
    "desc": "Holder's use of Rain Dance lasts 8 turns instead of 5.",
    "shortDesc": ""
  },
  "darkgem": {
    "name": "Dark Gem",
    "num": 562,
    "desc": "Holder's first successful Dark-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "darkmemory": {
    "name": "Dark Memory",
    "num": 919,
    "desc": "Holder's Multi-Attack is Dark type.",
    "shortDesc": ""
  },
  "darkiniumz": {
    "name": "Darkinium Z",
    "num": 791,
    "desc": "If holder has a Dark move, this item allows it to use a Dark Z-Move.",
    "shortDesc": ""
  },
  "dawnstone": {
    "name": "Dawn Stone",
    "num": 109,
    "desc": "Evolves male Kirlia into Gallade and female Snorunt into Froslass when used.",
    "shortDesc": "Evolves certain species of Pokemon when used."
  },
  "decidiumz": {
    "name": "Decidium Z",
    "num": 798,
    "desc": "If held by a Decidueye with Spirit Shackle, it can use Sinister Arrow Raid.",
    "shortDesc": ""
  },
  "deepseascale": {
    "name": "Deep Sea Scale",
    "num": 227,
    "desc": "If held by a Clamperl, its Sp. Def is doubled. Evolves Clamperl into Gorebyss when traded.",
    "shortDesc": "If held by a Clamperl, its Sp. Def is doubled."
  },
  "deepseatooth": {
    "name": "Deep Sea Tooth",
    "num": 226,
    "desc": "If held by a Clamperl, its Sp. Atk is doubled. Evolves Clamperl into Huntail when traded.",
    "shortDesc": "If held by a Clamperl, its Sp. Atk is doubled."
  },
  "destinyknot": {
    "name": "Destiny Knot",
    "num": 280,
    "desc": "If holder becomes infatuated, the other Pokemon also becomes infatuated.",
    "shortDesc": ""
  },
  "diancite": {
    "name": "Diancite",
    "num": 764,
    "desc": "If held by a Diancie, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "diveball": {
    "name": "Dive Ball",
    "num": 7,
    "desc": "A Poke Ball that works especially well on Pokemon that live underwater.",
    "shortDesc": ""
  },
  "domefossil": {
    "name": "Dome Fossil",
    "num": 102,
    "desc": "Can be revived into Kabuto.",
    "shortDesc": ""
  },
  "dousedrive": {
    "name": "Douse Drive",
    "num": 116,
    "desc": "Holder's Techno Blast is Water type.",
    "shortDesc": ""
  },
  "dracoplate": {
    "name": "Draco Plate",
    "num": 311,
    "desc": "Holder's Dragon-type attacks have 1.2x power. Judgment is Dragon type.",
    "shortDesc": ""
  },
  "dragonfang": {
    "name": "Dragon Fang",
    "num": 250,
    "desc": "Holder's Dragon-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "dragongem": {
    "name": "Dragon Gem",
    "num": 561,
    "desc": "Holder's first successful Dragon-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "dragonmemory": {
    "name": "Dragon Memory",
    "num": 918,
    "desc": "Holder's Multi-Attack is Dragon type.",
    "shortDesc": ""
  },
  "dragonscale": {
    "name": "Dragon Scale",
    "num": 235,
    "desc": "Evolves Seadra into Kingdra when traded.",
    "shortDesc": ""
  },
  "dragoniumz": {
    "name": "Dragonium Z",
    "num": 790,
    "desc": "If holder has a Dragon move, this item allows it to use a Dragon Z-Move.",
    "shortDesc": ""
  },
  "dreadplate": {
    "name": "Dread Plate",
    "num": 312,
    "desc": "Holder's Dark-type attacks have 1.2x power. Judgment is Dark type.",
    "shortDesc": ""
  },
  "dreamball": {
    "name": "Dream Ball",
    "num": 576,
    "desc": "A Poke Ball that makes it easier to catch wild Pokémon while they're asleep.",
    "shortDesc": ""
  },
  "dubiousdisc": {
    "name": "Dubious Disc",
    "num": 324,
    "desc": "Evolves Porygon2 into Porygon-Z when traded.",
    "shortDesc": ""
  },
  "durinberry": {
    "name": "Durin Berry",
    "num": 182,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "duskball": {
    "name": "Dusk Ball",
    "num": 13,
    "desc": "A Poke Ball that makes it easier to catch wild Pokemon at night or in caves.",
    "shortDesc": ""
  },
  "duskstone": {
    "name": "Dusk Stone",
    "num": 108,
    "desc": "Evolves Murkrow into Honchkrow, Misdreavus into Mismagius, Lampent into Chandelure, and Doublade into Aegislash when used.",
    "shortDesc": "Evolves certain species of Pokemon when used."
  },
  "earthplate": {
    "name": "Earth Plate",
    "num": 305,
    "desc": "Holder's Ground-type attacks have 1.2x power. Judgment is Ground type.",
    "shortDesc": ""
  },
  "eeviumz": {
    "name": "Eevium Z",
    "num": 805,
    "desc": "If held by an Eevee with Last Resort, it can use Extreme Evoboost.",
    "shortDesc": ""
  },
  "ejectbutton": {
    "name": "Eject Button",
    "num": 547,
    "desc": "If holder survives a hit, it immediately switches out to a chosen ally. Single use.",
    "shortDesc": ""
  },
  "ejectpack": {
    "name": "Eject Pack",
    "num": 1119,
    "desc": "If the holder's stat stages are lowered, it switches to a chosen ally. Single use.",
    "shortDesc": ""
  },
  "electirizer": {
    "name": "Electirizer",
    "num": 322,
    "desc": "Evolves Electabuzz into Electivire when traded.",
    "shortDesc": ""
  },
  "electricgem": {
    "name": "Electric Gem",
    "num": 550,
    "desc": "Holder's first successful Electric-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "electricmemory": {
    "name": "Electric Memory",
    "num": 915,
    "desc": "Holder's Multi-Attack is Electric type.",
    "shortDesc": ""
  },
  "electricseed": {
    "name": "Electric Seed",
    "num": 881,
    "desc": "If the terrain is Electric Terrain, raises holder's Defense by 1 stage. Single use.",
    "shortDesc": ""
  },
  "electriumz": {
    "name": "Electrium Z",
    "num": 779,
    "desc": "If holder has an Electric move, this item allows it to use an Electric Z-Move.",
    "shortDesc": ""
  },
  "enigmaberry": {
    "name": "Enigma Berry",
    "num": 208,
    "desc": "Restores 1/4 max HP after holder is hit by a supereffective move. Single use.",
    "shortDesc": ""
  },
  "eviolite": {
    "name": "Eviolite",
    "num": 538,
    "desc": "If holder's species can evolve, its Defense and Sp. Def are 1.5x.",
    "shortDesc": ""
  },
  "expertbelt": {
    "name": "Expert Belt",
    "num": 268,
    "desc": "Holder's attacks that are super effective against the target do 1.2x damage.",
    "shortDesc": ""
  },
  "fairiumz": {
    "name": "Fairium Z",
    "num": 793,
    "desc": "If holder has a Fairy move, this item allows it to use a Fairy Z-Move.",
    "shortDesc": ""
  },
  "fairyfeather": {
    "name": "Fairy Feather",
    "num": 2401,
    "desc": "Holder's Fairy-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "fairygem": {
    "name": "Fairy Gem",
    "num": 715,
    "desc": "Holder's first successful Fairy-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "fairymemory": {
    "name": "Fairy Memory",
    "num": 920,
    "desc": "Holder's Multi-Attack is Fairy type.",
    "shortDesc": ""
  },
  "fastball": {
    "name": "Fast Ball",
    "num": 492,
    "desc": "A Poke Ball that makes it easier to catch Pokemon which are quick to run away.",
    "shortDesc": ""
  },
  "fightinggem": {
    "name": "Fighting Gem",
    "num": 553,
    "desc": "Holder's first successful Fighting-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "fightingmemory": {
    "name": "Fighting Memory",
    "num": 904,
    "desc": "Holder's Multi-Attack is Fighting type.",
    "shortDesc": ""
  },
  "fightiniumz": {
    "name": "Fightinium Z",
    "num": 782,
    "desc": "If holder has a Fighting move, this item allows it to use a Fighting Z-Move.",
    "shortDesc": ""
  },
  "figyberry": {
    "name": "Figy Berry",
    "num": 159,
    "desc": "Restores 1/3 max HP at 1/4 max HP or less; confuses if -Atk Nature. Single use.",
    "shortDesc": ""
  },
  "firegem": {
    "name": "Fire Gem",
    "num": 548,
    "desc": "Holder's first successful Fire-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "firememory": {
    "name": "Fire Memory",
    "num": 912,
    "desc": "Holder's Multi-Attack is Fire type.",
    "shortDesc": ""
  },
  "firestone": {
    "name": "Fire Stone",
    "num": 82,
    "desc": "Evolves Vulpix into Ninetales, Growlithe into Arcanine, Eevee into Flareon, and Pansear into Simisear when used.",
    "shortDesc": "Evolves certain species of Pokemon when used."
  },
  "firiumz": {
    "name": "Firium Z",
    "num": 777,
    "desc": "If holder has a Fire move, this item allows it to use a Fire Z-Move.",
    "shortDesc": ""
  },
  "fistplate": {
    "name": "Fist Plate",
    "num": 303,
    "desc": "Holder's Fighting-type attacks have 1.2x power. Judgment is Fighting type.",
    "shortDesc": ""
  },
  "flameorb": {
    "name": "Flame Orb",
    "num": 273,
    "desc": "At the end of every turn, this item attempts to burn the holder.",
    "shortDesc": ""
  },
  "flameplate": {
    "name": "Flame Plate",
    "num": 298,
    "desc": "Holder's Fire-type attacks have 1.2x power. Judgment is Fire type.",
    "shortDesc": ""
  },
  "floatstone": {
    "name": "Float Stone",
    "num": 539,
    "desc": "Holder's weight is halved.",
    "shortDesc": ""
  },
  "flowersweet": {
    "name": "Flower Sweet",
    "num": 1113,
    "desc": "Evolves Milcery into Alcremie when held and spun around.",
    "shortDesc": ""
  },
  "flyinggem": {
    "name": "Flying Gem",
    "num": 556,
    "desc": "Holder's first successful Flying-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "flyingmemory": {
    "name": "Flying Memory",
    "num": 905,
    "desc": "Holder's Multi-Attack is Flying type.",
    "shortDesc": ""
  },
  "flyiniumz": {
    "name": "Flyinium Z",
    "num": 785,
    "desc": "If holder has a Flying move, this item allows it to use a Flying Z-Move.",
    "shortDesc": ""
  },
  "focusband": {
    "name": "Focus Band",
    "num": 230,
    "desc": "Holder has a 10% chance to survive an attack that would KO it with 1 HP.",
    "shortDesc": ""
  },
  "focussash": {
    "name": "Focus Sash",
    "num": 275,
    "desc": "If holder's HP is full, will survive an attack that would KO it with 1 HP. Single use.",
    "shortDesc": ""
  },
  "fossilizedbird": {
    "name": "Fossilized Bird",
    "num": 1105,
    "desc": "Can revive into Dracozolt with Fossilized Drake or Arctozolt with Fossilized Dino.",
    "shortDesc": ""
  },
  "fossilizeddino": {
    "name": "Fossilized Dino",
    "num": 1108,
    "desc": "Can revive into Arctovish with Fossilized Fish or Arctozolt with Fossilized Bird.",
    "shortDesc": ""
  },
  "fossilizeddrake": {
    "name": "Fossilized Drake",
    "num": 1107,
    "desc": "Can revive into Dracozolt with Fossilized Bird or Dracovish with Fossilized Fish.",
    "shortDesc": ""
  },
  "fossilizedfish": {
    "name": "Fossilized Fish",
    "num": 1106,
    "desc": "Can revive into Dracovish with Fossilized Drake or Arctovish with Fossilized Dino.",
    "shortDesc": ""
  },
  "friendball": {
    "name": "Friend Ball",
    "num": 497,
    "desc": "A Poke Ball that makes caught Pokemon more friendly.",
    "shortDesc": ""
  },
  "fullincense": {
    "name": "Full Incense",
    "num": 316,
    "desc": "Holder moves last in its priority bracket.",
    "shortDesc": ""
  },
  "galladite": {
    "name": "Galladite",
    "num": 756,
    "desc": "If held by a Gallade, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "ganlonberry": {
    "name": "Ganlon Berry",
    "num": 202,
    "desc": "Raises holder's Defense by 1 stage when at 1/4 max HP or less. Single use.",
    "shortDesc": ""
  },
  "garchompite": {
    "name": "Garchompite",
    "num": 683,
    "desc": "If held by a Garchomp, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "gardevoirite": {
    "name": "Gardevoirite",
    "num": 657,
    "desc": "If held by a Gardevoir, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "gengarite": {
    "name": "Gengarite",
    "num": 656,
    "desc": "If held by a Gengar, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "ghostgem": {
    "name": "Ghost Gem",
    "num": 560,
    "desc": "Holder's first successful Ghost-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "ghostmemory": {
    "name": "Ghost Memory",
    "num": 910,
    "desc": "Holder's Multi-Attack is Ghost type.",
    "shortDesc": ""
  },
  "ghostiumz": {
    "name": "Ghostium Z",
    "num": 789,
    "desc": "If holder has a Ghost move, this item allows it to use a Ghost Z-Move.",
    "shortDesc": ""
  },
  "glalitite": {
    "name": "Glalitite",
    "num": 763,
    "desc": "If held by a Glalie, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "goldbottlecap": {
    "name": "Gold Bottle Cap",
    "num": 796,
    "desc": "Used for Hyper Training. All of a Pokemon's stats are calculated with an IV of 31.",
    "shortDesc": ""
  },
  "grassgem": {
    "name": "Grass Gem",
    "num": 551,
    "desc": "Holder's first successful Grass-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "grassmemory": {
    "name": "Grass Memory",
    "num": 914,
    "desc": "Holder's Multi-Attack is Grass type.",
    "shortDesc": ""
  },
  "grassiumz": {
    "name": "Grassium Z",
    "num": 780,
    "desc": "If holder has a Grass move, this item allows it to use a Grass Z-Move.",
    "shortDesc": ""
  },
  "grassyseed": {
    "name": "Grassy Seed",
    "num": 884,
    "desc": "If the terrain is Grassy Terrain, raises holder's Defense by 1 stage. Single use.",
    "shortDesc": ""
  },
  "greatball": {
    "name": "Great Ball",
    "num": 3,
    "desc": "A high-performance Ball that provides a higher catch rate than a Poke Ball.",
    "shortDesc": ""
  },
  "grepaberry": {
    "name": "Grepa Berry",
    "num": 173,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "gripclaw": {
    "name": "Grip Claw",
    "num": 286,
    "desc": "Holder's partial-trapping moves always last 7 turns.",
    "shortDesc": ""
  },
  "griseouscore": {
    "name": "Griseous Core",
    "num": 1779,
    "desc": "If held by a Giratina, its Ghost- and Dragon-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "griseousorb": {
    "name": "Griseous Orb",
    "num": 112,
    "desc": "If held by a Giratina, its Ghost- and Dragon-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "groundgem": {
    "name": "Ground Gem",
    "num": 555,
    "desc": "Holder's first successful Ground-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "groundmemory": {
    "name": "Ground Memory",
    "num": 907,
    "desc": "Holder's Multi-Attack is Ground type.",
    "shortDesc": ""
  },
  "groundiumz": {
    "name": "Groundium Z",
    "num": 784,
    "desc": "If holder has a Ground move, this item allows it to use a Ground Z-Move.",
    "shortDesc": ""
  },
  "gyaradosite": {
    "name": "Gyaradosite",
    "num": 676,
    "desc": "If held by a Gyarados, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "habanberry": {
    "name": "Haban Berry",
    "num": 197,
    "desc": "Halves damage taken from a supereffective Dragon-type attack. Single use.",
    "shortDesc": ""
  },
  "hardstone": {
    "name": "Hard Stone",
    "num": 238,
    "desc": "Holder's Rock-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "healball": {
    "name": "Heal Ball",
    "num": 14,
    "desc": "A remedial Poke Ball that restores the caught Pokemon's HP and status problem.",
    "shortDesc": ""
  },
  "hearthflamemask": {
    "name": "Hearthflame Mask",
    "num": 2408,
    "desc": "Ogerpon-Hearthflame: 1.2x power attacks; Terastallize to gain Embody Aspect.",
    "shortDesc": ""
  },
  "heatrock": {
    "name": "Heat Rock",
    "num": 284,
    "desc": "Holder's use of Sunny Day lasts 8 turns instead of 5.",
    "shortDesc": ""
  },
  "heavyball": {
    "name": "Heavy Ball",
    "num": 495,
    "desc": "A Poke Ball for catching very heavy Pokemon.",
    "shortDesc": ""
  },
  "heavydutyboots": {
    "name": "Heavy-Duty Boots",
    "num": 1120,
    "desc": "When switching in, the holder is unaffected by hazards on its side of the field.",
    "shortDesc": ""
  },
  "helixfossil": {
    "name": "Helix Fossil",
    "num": 101,
    "desc": "Can be revived into Omanyte.",
    "shortDesc": ""
  },
  "heracronite": {
    "name": "Heracronite",
    "num": 680,
    "desc": "If held by a Heracross, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "hondewberry": {
    "name": "Hondew Berry",
    "num": 172,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "houndoominite": {
    "name": "Houndoominite",
    "num": 666,
    "desc": "If held by a Houndoom, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "iapapaberry": {
    "name": "Iapapa Berry",
    "num": 163,
    "desc": "Restores 1/3 max HP at 1/4 max HP or less; confuses if -Def Nature. Single use.",
    "shortDesc": ""
  },
  "icegem": {
    "name": "Ice Gem",
    "num": 552,
    "desc": "Holder's first successful Ice-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "icememory": {
    "name": "Ice Memory",
    "num": 917,
    "desc": "Holder's Multi-Attack is Ice type.",
    "shortDesc": ""
  },
  "icestone": {
    "name": "Ice Stone",
    "num": 849,
    "desc": "Evolves Alolan Sandshrew into Alolan Sandslash, Alolan Vulpix into Alolan Ninetales, Eevee into Glaceon, and Galarian Darumaka into Galarian Darmanitan when used.",
    "shortDesc": "Evolves certain species of Pokemon when used."
  },
  "icicleplate": {
    "name": "Icicle Plate",
    "num": 302,
    "desc": "Holder's Ice-type attacks have 1.2x power. Judgment is Ice type.",
    "shortDesc": ""
  },
  "iciumz": {
    "name": "Icium Z",
    "num": 781,
    "desc": "If holder has an Ice move, this item allows it to use an Ice Z-Move.",
    "shortDesc": ""
  },
  "icyrock": {
    "name": "Icy Rock",
    "num": 282,
    "desc": "Holder's use of Hail lasts 8 turns instead of 5.",
    "shortDesc": ""
  },
  "inciniumz": {
    "name": "Incinium Z",
    "num": 799,
    "desc": "If held by an Incineroar with Darkest Lariat, it can use Malicious Moonsault.",
    "shortDesc": ""
  },
  "insectplate": {
    "name": "Insect Plate",
    "num": 308,
    "desc": "Holder's Bug-type attacks have 1.2x power. Judgment is Bug type.",
    "shortDesc": ""
  },
  "ironball": {
    "name": "Iron Ball",
    "num": 278,
    "desc": "Holder is grounded, Speed halved. If Flying type, takes neutral Ground damage.",
    "shortDesc": ""
  },
  "ironplate": {
    "name": "Iron Plate",
    "num": 313,
    "desc": "Holder's Steel-type attacks have 1.2x power. Judgment is Steel type.",
    "shortDesc": ""
  },
  "jabocaberry": {
    "name": "Jaboca Berry",
    "num": 211,
    "desc": "If holder is hit by a physical move, attacker loses 1/8 of its max HP. Single use.",
    "shortDesc": ""
  },
  "jawfossil": {
    "name": "Jaw Fossil",
    "num": 710,
    "desc": "Can be revived into Tyrunt.",
    "shortDesc": ""
  },
  "kasibberry": {
    "name": "Kasib Berry",
    "num": 196,
    "desc": "Halves damage taken from a supereffective Ghost-type attack. Single use.",
    "shortDesc": ""
  },
  "kebiaberry": {
    "name": "Kebia Berry",
    "num": 190,
    "desc": "Halves damage taken from a supereffective Poison-type attack. Single use.",
    "shortDesc": ""
  },
  "keeberry": {
    "name": "Kee Berry",
    "num": 687,
    "desc": "Raises holder's Defense by 1 stage after it is hit by a physical attack. Single use.",
    "shortDesc": ""
  },
  "kelpsyberry": {
    "name": "Kelpsy Berry",
    "num": 170,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "kangaskhanite": {
    "name": "Kangaskhanite",
    "num": 675,
    "desc": "If held by a Kangaskhan, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "kingsrock": {
    "name": "King's Rock",
    "num": 221,
    "desc": "Holder's attacks without a chance to make the target flinch gain a 10% chance to make the target flinch. Evolves Poliwhirl into Politoed and Slowpoke into Slowking when traded.",
    "shortDesc": "Holder's attacks without a chance to flinch gain a 10% chance to flinch."
  },
  "kommoniumz": {
    "name": "Kommonium Z",
    "num": 926,
    "desc": "If held by a Kommo-o with Clanging Scales, it can use Clangorous Soulblaze.",
    "shortDesc": ""
  },
  "laggingtail": {
    "name": "Lagging Tail",
    "num": 279,
    "desc": "Holder moves last in its priority bracket.",
    "shortDesc": ""
  },
  "lansatberry": {
    "name": "Lansat Berry",
    "num": 206,
    "desc": "Holder gains the Focus Energy effect when at 1/4 max HP or less. Single use.",
    "shortDesc": ""
  },
  "latiasite": {
    "name": "Latiasite",
    "num": 684,
    "desc": "If held by a Latias, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "latiosite": {
    "name": "Latiosite",
    "num": 685,
    "desc": "If held by a Latios, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "laxincense": {
    "name": "Lax Incense",
    "num": 255,
    "desc": "The accuracy of attacks against the holder is 0.9x.",
    "shortDesc": ""
  },
  "leafstone": {
    "name": "Leaf Stone",
    "num": 85,
    "desc": "Evolves Gloom into Vileplume, Weepinbell into Victreebel, Exeggcute into Exeggutor or Alolan Exeggutor, Eevee into Leafeon, Nuzleaf into Shiftry, and Pansage into Simisage when used.",
    "shortDesc": "Evolves certain species of Pokemon when used."
  },
  "leek": {
    "name": "Leek",
    "num": 259,
    "desc": "If held by a Farfetch’d or Sirfetch’d, its critical hit ratio is raised by 2 stages.",
    "shortDesc": ""
  },
  "leftovers": {
    "name": "Leftovers",
    "num": 234,
    "desc": "At the end of every turn, holder restores 1/16 of its max HP.",
    "shortDesc": ""
  },
  "leppaberry": {
    "name": "Leppa Berry",
    "num": 154,
    "desc": "Restores 10 PP to the first of the holder's moves to reach 0 PP. Single use.",
    "shortDesc": ""
  },
  "levelball": {
    "name": "Level Ball",
    "num": 493,
    "desc": "A Poke Ball for catching Pokemon that are a lower level than your own.",
    "shortDesc": ""
  },
  "liechiberry": {
    "name": "Liechi Berry",
    "num": 201,
    "desc": "Raises holder's Attack by 1 stage when at 1/4 max HP or less. Single use.",
    "shortDesc": ""
  },
  "lifeorb": {
    "name": "Life Orb",
    "num": 270,
    "desc": "Holder's attacks do 1.3x damage, and it loses 1/10 its max HP after the attack.",
    "shortDesc": ""
  },
  "lightball": {
    "name": "Light Ball",
    "num": 236,
    "desc": "If held by a Pikachu, its Attack and Sp. Atk are doubled.",
    "shortDesc": ""
  },
  "lightclay": {
    "name": "Light Clay",
    "num": 269,
    "desc": "Holder's use of Aurora Veil, Light Screen, or Reflect lasts 8 turns instead of 5.",
    "shortDesc": ""
  },
  "loadeddice": {
    "name": "Loaded Dice",
    "num": 1886,
    "desc": "Holder's moves that hit 2-5 times hit 4-5 times; Population Bomb hits 4-10 times.",
    "shortDesc": ""
  },
  "lopunnite": {
    "name": "Lopunnite",
    "num": 768,
    "desc": "If held by a Lopunny, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "loveball": {
    "name": "Love Ball",
    "num": 496,
    "desc": "Poke Ball for catching Pokemon that are the opposite gender of your Pokemon.",
    "shortDesc": ""
  },
  "lovesweet": {
    "name": "Love Sweet",
    "num": 1110,
    "desc": "Evolves Milcery into Alcremie when held and spun around.",
    "shortDesc": ""
  },
  "lucarionite": {
    "name": "Lucarionite",
    "num": 673,
    "desc": "If held by a Lucario, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "luckypunch": {
    "name": "Lucky Punch",
    "num": 256,
    "desc": "If held by a Chansey, its critical hit ratio is raised by 2 stages.",
    "shortDesc": ""
  },
  "lumberry": {
    "name": "Lum Berry",
    "num": 157,
    "desc": "Holder cures itself if it has a non-volatile status or is confused. Single use.",
    "shortDesc": ""
  },
  "luminousmoss": {
    "name": "Luminous Moss",
    "num": 648,
    "desc": "Raises holder's Sp. Def by 1 stage if hit by a Water-type attack. Single use.",
    "shortDesc": ""
  },
  "lunaliumz": {
    "name": "Lunalium Z",
    "num": 922,
    "desc": "Lunala or Dawn Wings Necrozma with Moongeist Beam can use a special Z-Move.",
    "shortDesc": ""
  },
  "lureball": {
    "name": "Lure Ball",
    "num": 494,
    "desc": "A Poke Ball for catching Pokemon hooked by a Rod when fishing.",
    "shortDesc": ""
  },
  "lustrousglobe": {
    "name": "Lustrous Globe",
    "num": 1778,
    "desc": "If held by a Palkia, its Water- and Dragon-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "lustrousorb": {
    "name": "Lustrous Orb",
    "num": 136,
    "desc": "If held by a Palkia, its Water- and Dragon-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "luxuryball": {
    "name": "Luxury Ball",
    "num": 11,
    "desc": "A comfortable Poke Ball that makes a caught wild Pokemon quickly grow friendly.",
    "shortDesc": ""
  },
  "lycaniumz": {
    "name": "Lycanium Z",
    "num": 925,
    "desc": "If held by a Lycanroc forme with Stone Edge, it can use Splintered Stormshards.",
    "shortDesc": ""
  },
  "machobrace": {
    "name": "Macho Brace",
    "num": 215,
    "desc": "Holder's Speed is halved. The Klutz Ability does not ignore this effect.",
    "shortDesc": ""
  },
  "magmarizer": {
    "name": "Magmarizer",
    "num": 323,
    "desc": "Evolves Magmar into Magmortar when traded.",
    "shortDesc": ""
  },
  "magnet": {
    "name": "Magnet",
    "num": 242,
    "desc": "Holder's Electric-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "magoberry": {
    "name": "Mago Berry",
    "num": 161,
    "desc": "Restores 1/3 max HP at 1/4 max HP or less; confuses if -Spe Nature. Single use.",
    "shortDesc": ""
  },
  "magostberry": {
    "name": "Magost Berry",
    "num": 176,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "mail": {
    "name": "Mail",
    "num": 137,
    "desc": "Cannot be given to or taken from a Pokemon, except by Covet/Knock Off/Thief.",
    "shortDesc": ""
  },
  "maliciousarmor": {
    "name": "Malicious Armor",
    "num": 1861,
    "desc": "Evolves Charcadet into Ceruledge when used.",
    "shortDesc": ""
  },
  "manectite": {
    "name": "Manectite",
    "num": 682,
    "desc": "If held by a Manectric, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "marangaberry": {
    "name": "Maranga Berry",
    "num": 688,
    "desc": "Raises holder's Sp. Def by 1 stage after it is hit by a special attack. Single use.",
    "shortDesc": ""
  },
  "marshadiumz": {
    "name": "Marshadium Z",
    "num": 802,
    "desc": "If held by Marshadow with Spectral Thief, it can use Soul-Stealing 7-Star Strike.",
    "shortDesc": ""
  },
  "masterball": {
    "name": "Master Ball",
    "num": 1,
    "desc": "The best Ball with the ultimate performance. It will catch any wild Pokemon.",
    "shortDesc": ""
  },
  "masterpieceteacup": {
    "name": "Masterpiece Teacup",
    "num": 2404,
    "desc": "Evolves Poltchageist-Artisan into Sinistcha-Masterpiece when used.",
    "shortDesc": ""
  },
  "mawilite": {
    "name": "Mawilite",
    "num": 681,
    "desc": "If held by a Mawile, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "meadowplate": {
    "name": "Meadow Plate",
    "num": 301,
    "desc": "Holder's Grass-type attacks have 1.2x power. Judgment is Grass type.",
    "shortDesc": ""
  },
  "medichamite": {
    "name": "Medichamite",
    "num": 665,
    "desc": "If held by a Medicham, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "mentalherb": {
    "name": "Mental Herb",
    "num": 219,
    "desc": "Cures holder of Attract, Disable, Encore, Heal Block, Taunt, Torment. Single use.",
    "shortDesc": ""
  },
  "metagrossite": {
    "name": "Metagrossite",
    "num": 758,
    "desc": "If held by a Metagross, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "metalcoat": {
    "name": "Metal Coat",
    "num": 233,
    "desc": "Holder's Steel-type attacks have 1.2x power. Evolves Onix into Steelix and Scyther into Scizor when traded.",
    "shortDesc": "Holder's Steel-type attacks have 1.2x power."
  },
  "metalpowder": {
    "name": "Metal Powder",
    "num": 257,
    "desc": "If held by a Ditto that hasn't Transformed, its Defense is doubled.",
    "shortDesc": ""
  },
  "metronome": {
    "name": "Metronome",
    "num": 277,
    "desc": "Damage of moves used on consecutive turns is increased. Max 2x after 5 turns.",
    "shortDesc": ""
  },
  "mewniumz": {
    "name": "Mewnium Z",
    "num": 806,
    "desc": "If held by a Mew with Psychic, it can use Genesis Supernova.",
    "shortDesc": ""
  },
  "mewtwonitex": {
    "name": "Mewtwonite X",
    "num": 662,
    "desc": "If held by a Mewtwo, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "mewtwonitey": {
    "name": "Mewtwonite Y",
    "num": 663,
    "desc": "If held by a Mewtwo, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "micleberry": {
    "name": "Micle Berry",
    "num": 209,
    "desc": "Holder's next move has 1.2x accuracy when at 1/4 max HP or less. Single use.",
    "shortDesc": ""
  },
  "mimikiumz": {
    "name": "Mimikium Z",
    "num": 924,
    "desc": "If held by a Mimikyu with Play Rough, it can use Let's Snuggle Forever.",
    "shortDesc": ""
  },
  "mindplate": {
    "name": "Mind Plate",
    "num": 307,
    "desc": "Holder's Psychic-type attacks have 1.2x power. Judgment is Psychic type.",
    "shortDesc": ""
  },
  "miracleseed": {
    "name": "Miracle Seed",
    "num": 239,
    "desc": "Holder's Grass-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "mirrorherb": {
    "name": "Mirror Herb",
    "num": 1883,
    "desc": "When an opposing Pokemon raises a stat stage, the holder copies it. Single use.",
    "shortDesc": ""
  },
  "mistyseed": {
    "name": "Misty Seed",
    "num": 883,
    "desc": "If the terrain is Misty Terrain, raises holder's Sp. Def by 1 stage. Single use.",
    "shortDesc": ""
  },
  "moonball": {
    "name": "Moon Ball",
    "num": 498,
    "desc": "A Poke Ball for catching Pokemon that evolve using the Moon Stone.",
    "shortDesc": ""
  },
  "moonstone": {
    "name": "Moon Stone",
    "num": 81,
    "desc": "Evolves Nidorina into Nidoqueen, Nidorino into Nidoking, Clefairy into Clefable, Jigglypuff into Wigglytuff, Skitty into Delcatty, and Munna into Musharna when used.",
    "shortDesc": "Evolves certain species of Pokemon when used."
  },
  "muscleband": {
    "name": "Muscle Band",
    "num": 266,
    "desc": "Holder's physical attacks have 1.1x power.",
    "shortDesc": ""
  },
  "mysticwater": {
    "name": "Mystic Water",
    "num": 243,
    "desc": "Holder's Water-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "nanabberry": {
    "name": "Nanab Berry",
    "num": 166,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "nestball": {
    "name": "Nest Ball",
    "num": 8,
    "desc": "A Poke Ball that works especially well on weaker Pokemon in the wild.",
    "shortDesc": ""
  },
  "netball": {
    "name": "Net Ball",
    "num": 6,
    "desc": "A Poke Ball that works especially well on Water- and Bug-type Pokemon.",
    "shortDesc": ""
  },
  "nevermeltice": {
    "name": "Never-Melt Ice",
    "num": 246,
    "desc": "Holder's Ice-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "nomelberry": {
    "name": "Nomel Berry",
    "num": 178,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "normalgem": {
    "name": "Normal Gem",
    "num": 564,
    "desc": "Holder's first successful Normal-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "normaliumz": {
    "name": "Normalium Z",
    "num": 776,
    "desc": "If holder has a Normal move, this item allows it to use a Normal Z-Move.",
    "shortDesc": ""
  },
  "occaberry": {
    "name": "Occa Berry",
    "num": 184,
    "desc": "Halves damage taken from a supereffective Fire-type attack. Single use.",
    "shortDesc": ""
  },
  "oddincense": {
    "name": "Odd Incense",
    "num": 314,
    "desc": "Holder's Psychic-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "oldamber": {
    "name": "Old Amber",
    "num": 103,
    "desc": "Can be revived into Aerodactyl.",
    "shortDesc": ""
  },
  "oranberry": {
    "name": "Oran Berry",
    "num": 155,
    "desc": "Restores 10 HP when at 1/2 max HP or less. Single use.",
    "shortDesc": ""
  },
  "ovalstone": {
    "name": "Oval Stone",
    "num": 110,
    "desc": "Evolves Happiny into Chansey when held and leveled up during the day.",
    "shortDesc": ""
  },
  "pamtreberry": {
    "name": "Pamtre Berry",
    "num": 180,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "passhoberry": {
    "name": "Passho Berry",
    "num": 185,
    "desc": "Halves damage taken from a supereffective Water-type attack. Single use.",
    "shortDesc": ""
  },
  "payapaberry": {
    "name": "Payapa Berry",
    "num": 193,
    "desc": "Halves damage taken from a supereffective Psychic-type attack. Single use.",
    "shortDesc": ""
  },
  "pechaberry": {
    "name": "Pecha Berry",
    "num": 151,
    "desc": "Holder is cured if it is poisoned. Single use.",
    "shortDesc": ""
  },
  "persimberry": {
    "name": "Persim Berry",
    "num": 156,
    "desc": "Holder is cured if it is confused. Single use.",
    "shortDesc": ""
  },
  "petayaberry": {
    "name": "Petaya Berry",
    "num": 204,
    "desc": "Raises holder's Sp. Atk by 1 stage when at 1/4 max HP or less. Single use.",
    "shortDesc": ""
  },
  "pidgeotite": {
    "name": "Pidgeotite",
    "num": 762,
    "desc": "If held by a Pidgeot, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "pikaniumz": {
    "name": "Pikanium Z",
    "num": 794,
    "desc": "If held by a Pikachu with Volt Tackle, it can use Catastropika.",
    "shortDesc": ""
  },
  "pikashuniumz": {
    "name": "Pikashunium Z",
    "num": 836,
    "desc": "If held by cap Pikachu with Thunderbolt, it can use 10,000,000 Volt Thunderbolt.",
    "shortDesc": ""
  },
  "pinapberry": {
    "name": "Pinap Berry",
    "num": 168,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "pinsirite": {
    "name": "Pinsirite",
    "num": 671,
    "desc": "If held by a Pinsir, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "pixieplate": {
    "name": "Pixie Plate",
    "num": 644,
    "desc": "Holder's Fairy-type attacks have 1.2x power. Judgment is Fairy type.",
    "shortDesc": ""
  },
  "plumefossil": {
    "name": "Plume Fossil",
    "num": 573,
    "desc": "Can be revived into Archen.",
    "shortDesc": ""
  },
  "poisonbarb": {
    "name": "Poison Barb",
    "num": 245,
    "desc": "Holder's Poison-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "poisongem": {
    "name": "Poison Gem",
    "num": 554,
    "desc": "Holder's first successful Poison-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "poisonmemory": {
    "name": "Poison Memory",
    "num": 906,
    "desc": "Holder's Multi-Attack is Poison type.",
    "shortDesc": ""
  },
  "poisoniumz": {
    "name": "Poisonium Z",
    "num": 783,
    "desc": "If holder has a Poison move, this item allows it to use a Poison Z-Move.",
    "shortDesc": ""
  },
  "pokeball": {
    "name": "Poke Ball",
    "num": 4,
    "desc": "A device for catching wild Pokemon. It is designed as a capsule system.",
    "shortDesc": ""
  },
  "pomegberry": {
    "name": "Pomeg Berry",
    "num": 169,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "poweranklet": {
    "name": "Power Anklet",
    "num": 293,
    "desc": "Holder's Speed is halved. The Klutz Ability does not ignore this effect.",
    "shortDesc": ""
  },
  "powerband": {
    "name": "Power Band",
    "num": 292,
    "desc": "Holder's Speed is halved. The Klutz Ability does not ignore this effect.",
    "shortDesc": ""
  },
  "powerbelt": {
    "name": "Power Belt",
    "num": 290,
    "desc": "Holder's Speed is halved. The Klutz Ability does not ignore this effect.",
    "shortDesc": ""
  },
  "powerbracer": {
    "name": "Power Bracer",
    "num": 289,
    "desc": "Holder's Speed is halved. The Klutz Ability does not ignore this effect.",
    "shortDesc": ""
  },
  "powerherb": {
    "name": "Power Herb",
    "num": 271,
    "desc": "Holder's two-turn moves complete in one turn (except Sky Drop). Single use.",
    "shortDesc": ""
  },
  "powerlens": {
    "name": "Power Lens",
    "num": 291,
    "desc": "Holder's Speed is halved. The Klutz Ability does not ignore this effect.",
    "shortDesc": ""
  },
  "powerweight": {
    "name": "Power Weight",
    "num": 294,
    "desc": "Holder's Speed is halved. The Klutz Ability does not ignore this effect.",
    "shortDesc": ""
  },
  "premierball": {
    "name": "Premier Ball",
    "num": 12,
    "desc": "A rare Poke Ball that has been crafted to commemorate an event.",
    "shortDesc": ""
  },
  "primariumz": {
    "name": "Primarium Z",
    "num": 800,
    "desc": "If held by a Primarina with Sparkling Aria, it can use Oceanic Operetta.",
    "shortDesc": ""
  },
  "prismscale": {
    "name": "Prism Scale",
    "num": 537,
    "desc": "Evolves Feebas into Milotic when traded.",
    "shortDesc": ""
  },
  "protectivepads": {
    "name": "Protective Pads",
    "num": 880,
    "desc": "Holder's moves are protected from adverse contact effects, except Pickpocket.",
    "shortDesc": ""
  },
  "protector": {
    "name": "Protector",
    "num": 321,
    "desc": "Evolves Rhydon into Rhyperior when traded.",
    "shortDesc": ""
  },
  "psychicgem": {
    "name": "Psychic Gem",
    "num": 557,
    "desc": "Holder's first successful Psychic-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "psychicmemory": {
    "name": "Psychic Memory",
    "num": 916,
    "desc": "Holder's Multi-Attack is Psychic type.",
    "shortDesc": ""
  },
  "psychicseed": {
    "name": "Psychic Seed",
    "num": 882,
    "desc": "If the terrain is Psychic Terrain, raises holder's Sp. Def by 1 stage. Single use.",
    "shortDesc": ""
  },
  "psychiumz": {
    "name": "Psychium Z",
    "num": 786,
    "desc": "If holder has a Psychic move, this item allows it to use a Psychic Z-Move.",
    "shortDesc": ""
  },
  "punchingglove": {
    "name": "Punching Glove",
    "num": 1884,
    "desc": "Holder's punch-based attacks have 1.1x power and do not make contact.",
    "shortDesc": ""
  },
  "qualotberry": {
    "name": "Qualot Berry",
    "num": 171,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "quickball": {
    "name": "Quick Ball",
    "num": 15,
    "desc": "A Poke Ball that provides a better catch rate at the start of a wild encounter.",
    "shortDesc": ""
  },
  "quickclaw": {
    "name": "Quick Claw",
    "num": 217,
    "desc": "Each turn, holder has a 20% chance to move first in its priority bracket.",
    "shortDesc": ""
  },
  "quickpowder": {
    "name": "Quick Powder",
    "num": 274,
    "desc": "If held by a Ditto that hasn't Transformed, its Speed is doubled.",
    "shortDesc": ""
  },
  "rabutaberry": {
    "name": "Rabuta Berry",
    "num": 177,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "rarebone": {
    "name": "Rare Bone",
    "num": 106,
    "desc": "No competitive use other than when used with Fling.",
    "shortDesc": ""
  },
  "rawstberry": {
    "name": "Rawst Berry",
    "num": 152,
    "desc": "Holder is cured if it is burned. Single use.",
    "shortDesc": ""
  },
  "razorclaw": {
    "name": "Razor Claw",
    "num": 326,
    "desc": "Holder's critical hit ratio is raised by 1 stage. Evolves Sneasel into Weavile when held and leveled up during the night.",
    "shortDesc": "Holder's critical hit ratio is raised by 1 stage."
  },
  "razorfang": {
    "name": "Razor Fang",
    "num": 327,
    "desc": "Holder's attacks without a chance to make the target flinch gain a 10% chance to make the target flinch. Evolves Gligar into Gliscor when held and leveled up during the night.",
    "shortDesc": "Holder's attacks without a chance to flinch gain a 10% chance to flinch."
  },
  "razzberry": {
    "name": "Razz Berry",
    "num": 164,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "reapercloth": {
    "name": "Reaper Cloth",
    "num": 325,
    "desc": "Evolves Dusclops into Dusknoir when traded.",
    "shortDesc": ""
  },
  "redcard": {
    "name": "Red Card",
    "num": 542,
    "desc": "If holder survives a hit, attacker is forced to switch to a random ally. Single use.",
    "shortDesc": ""
  },
  "redorb": {
    "name": "Red Orb",
    "num": 534,
    "desc": "If held by a Groudon, this item triggers its Primal Reversion in battle.",
    "shortDesc": ""
  },
  "repeatball": {
    "name": "Repeat Ball",
    "num": 9,
    "desc": "A Poke Ball that works well on Pokemon species that were previously caught.",
    "shortDesc": ""
  },
  "ribbonsweet": {
    "name": "Ribbon Sweet",
    "num": 1115,
    "desc": "Evolves Milcery into Alcremie when held and spun around.",
    "shortDesc": ""
  },
  "rindoberry": {
    "name": "Rindo Berry",
    "num": 187,
    "desc": "Halves damage taken from a supereffective Grass-type attack. Single use.",
    "shortDesc": ""
  },
  "ringtarget": {
    "name": "Ring Target",
    "num": 543,
    "desc": "The holder's type immunities granted solely by its typing are negated.",
    "shortDesc": ""
  },
  "rockgem": {
    "name": "Rock Gem",
    "num": 559,
    "desc": "Holder's first successful Rock-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "rockincense": {
    "name": "Rock Incense",
    "num": 315,
    "desc": "Holder's Rock-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "rockmemory": {
    "name": "Rock Memory",
    "num": 908,
    "desc": "Holder's Multi-Attack is Rock type.",
    "shortDesc": ""
  },
  "rockiumz": {
    "name": "Rockium Z",
    "num": 788,
    "desc": "If holder has a Rock move, this item allows it to use a Rock Z-Move.",
    "shortDesc": ""
  },
  "rockyhelmet": {
    "name": "Rocky Helmet",
    "num": 540,
    "desc": "If holder is hit by a contact move, the attacker loses 1/6 of its max HP.",
    "shortDesc": ""
  },
  "roomservice": {
    "name": "Room Service",
    "num": 1122,
    "desc": "If Trick Room is active, the holder's Speed is lowered by 1 stage. Single use.",
    "shortDesc": ""
  },
  "rootfossil": {
    "name": "Root Fossil",
    "num": 99,
    "desc": "Can be revived into Lileep.",
    "shortDesc": ""
  },
  "roseincense": {
    "name": "Rose Incense",
    "num": 318,
    "desc": "Holder's Grass-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "roseliberry": {
    "name": "Roseli Berry",
    "num": 686,
    "desc": "Halves damage taken from a supereffective Fairy-type attack. Single use.",
    "shortDesc": ""
  },
  "rowapberry": {
    "name": "Rowap Berry",
    "num": 212,
    "desc": "If holder is hit by a special move, attacker loses 1/8 of its max HP. Single use.",
    "shortDesc": ""
  },
  "rustedshield": {
    "name": "Rusted Shield",
    "num": 1104,
    "desc": "If held by a Zamazenta, this item changes its forme to Crowned Shield.",
    "shortDesc": ""
  },
  "rustedsword": {
    "name": "Rusted Sword",
    "num": 1103,
    "desc": "If held by a Zacian, this item changes its forme to Crowned Sword.",
    "shortDesc": ""
  },
  "sablenite": {
    "name": "Sablenite",
    "num": 754,
    "desc": "If held by a Sableye, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "sachet": {
    "name": "Sachet",
    "num": 647,
    "desc": "Evolves Spritzee into Aromatisse when traded.",
    "shortDesc": ""
  },
  "safetygoggles": {
    "name": "Safety Goggles",
    "num": 650,
    "desc": "Holder is immune to powder moves and damage from Sandstorm or Hail.",
    "shortDesc": ""
  },
  "sailfossil": {
    "name": "Sail Fossil",
    "num": 711,
    "desc": "Can be revived into Amaura.",
    "shortDesc": ""
  },
  "salacberry": {
    "name": "Salac Berry",
    "num": 203,
    "desc": "Raises holder's Speed by 1 stage when at 1/4 max HP or less. Single use.",
    "shortDesc": ""
  },
  "salamencite": {
    "name": "Salamencite",
    "num": 769,
    "desc": "If held by a Salamence, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "sceptilite": {
    "name": "Sceptilite",
    "num": 753,
    "desc": "If held by a Sceptile, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "scizorite": {
    "name": "Scizorite",
    "num": 670,
    "desc": "If held by a Scizor, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "scopelens": {
    "name": "Scope Lens",
    "num": 232,
    "desc": "Holder's critical hit ratio is raised by 1 stage.",
    "shortDesc": ""
  },
  "seaincense": {
    "name": "Sea Incense",
    "num": 254,
    "desc": "Holder's Water-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "sharpbeak": {
    "name": "Sharp Beak",
    "num": 244,
    "desc": "Holder's Flying-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "sharpedonite": {
    "name": "Sharpedonite",
    "num": 759,
    "desc": "If held by a Sharpedo, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "shedshell": {
    "name": "Shed Shell",
    "num": 295,
    "desc": "Holder may switch out even when trapped by another Pokemon, or by Ingrain.",
    "shortDesc": ""
  },
  "shellbell": {
    "name": "Shell Bell",
    "num": 253,
    "desc": "After an attack, holder gains 1/8 of the damage in HP dealt to other Pokemon.",
    "shortDesc": ""
  },
  "shinystone": {
    "name": "Shiny Stone",
    "num": 107,
    "desc": "Evolves Togetic into Togekiss, Roselia into Roserade, Minccino into Cinccino, and Floette into Florges when used.",
    "shortDesc": "Evolves certain species of Pokemon when used."
  },
  "shockdrive": {
    "name": "Shock Drive",
    "num": 117,
    "desc": "Holder's Techno Blast is Electric type.",
    "shortDesc": ""
  },
  "shucaberry": {
    "name": "Shuca Berry",
    "num": 191,
    "desc": "Halves damage taken from a supereffective Ground-type attack. Single use.",
    "shortDesc": ""
  },
  "silkscarf": {
    "name": "Silk Scarf",
    "num": 251,
    "desc": "Holder's Normal-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "silverpowder": {
    "name": "Silver Powder",
    "num": 222,
    "desc": "Holder's Bug-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "sitrusberry": {
    "name": "Sitrus Berry",
    "num": 158,
    "desc": "Restores 1/4 max HP when at 1/2 max HP or less. Single use.",
    "shortDesc": ""
  },
  "skullfossil": {
    "name": "Skull Fossil",
    "num": 105,
    "desc": "Can be revived into Cranidos.",
    "shortDesc": ""
  },
  "skyplate": {
    "name": "Sky Plate",
    "num": 306,
    "desc": "Holder's Flying-type attacks have 1.2x power. Judgment is Flying type.",
    "shortDesc": ""
  },
  "slowbronite": {
    "name": "Slowbronite",
    "num": 760,
    "desc": "If held by a Slowbro, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "smoothrock": {
    "name": "Smooth Rock",
    "num": 283,
    "desc": "Holder's use of Sandstorm lasts 8 turns instead of 5.",
    "shortDesc": ""
  },
  "snorliumz": {
    "name": "Snorlium Z",
    "num": 804,
    "desc": "If held by a Snorlax with Giga Impact, it can use Pulverizing Pancake.",
    "shortDesc": ""
  },
  "snowball": {
    "name": "Snowball",
    "num": 649,
    "desc": "Raises holder's Attack by 1 if hit by an Ice-type attack. Single use.",
    "shortDesc": ""
  },
  "softsand": {
    "name": "Soft Sand",
    "num": 237,
    "desc": "Holder's Ground-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "solganiumz": {
    "name": "Solganium Z",
    "num": 921,
    "desc": "Solgaleo or Dusk Mane Necrozma with Sunsteel Strike can use a special Z-Move.",
    "shortDesc": ""
  },
  "souldew": {
    "name": "Soul Dew",
    "num": 225,
    "desc": "If held by a Latias/Latios, its Dragon- and Psychic-type moves have 1.2x power.",
    "shortDesc": ""
  },
  "spelltag": {
    "name": "Spell Tag",
    "num": 247,
    "desc": "Holder's Ghost-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "spelonberry": {
    "name": "Spelon Berry",
    "num": 179,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "splashplate": {
    "name": "Splash Plate",
    "num": 299,
    "desc": "Holder's Water-type attacks have 1.2x power. Judgment is Water type.",
    "shortDesc": ""
  },
  "spookyplate": {
    "name": "Spooky Plate",
    "num": 310,
    "desc": "Holder's Ghost-type attacks have 1.2x power. Judgment is Ghost type.",
    "shortDesc": ""
  },
  "starfberry": {
    "name": "Starf Berry",
    "num": 207,
    "desc": "Raises a random stat by 2 when at 1/4 max HP or less (not acc/eva). Single use.",
    "shortDesc": ""
  },
  "starsweet": {
    "name": "Star Sweet",
    "num": 1114,
    "desc": "Evolves Milcery into Alcremie when held and spun around.",
    "shortDesc": ""
  },
  "steelixite": {
    "name": "Steelixite",
    "num": 761,
    "desc": "If held by a Steelix, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "steelgem": {
    "name": "Steel Gem",
    "num": 563,
    "desc": "Holder's first successful Steel-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "steelmemory": {
    "name": "Steel Memory",
    "num": 911,
    "desc": "Holder's Multi-Attack is Steel type.",
    "shortDesc": ""
  },
  "steeliumz": {
    "name": "Steelium Z",
    "num": 792,
    "desc": "If holder has a Steel move, this item allows it to use a Steel Z-Move.",
    "shortDesc": ""
  },
  "stick": {
    "name": "Stick",
    "num": 259,
    "desc": "If held by a Farfetch’d, its critical hit ratio is raised by 2 stages.",
    "shortDesc": ""
  },
  "stickybarb": {
    "name": "Sticky Barb",
    "num": 288,
    "desc": "Each turn, holder loses 1/8 max HP. An attacker making contact can receive it.",
    "shortDesc": ""
  },
  "stoneplate": {
    "name": "Stone Plate",
    "num": 309,
    "desc": "Holder's Rock-type attacks have 1.2x power. Judgment is Rock type.",
    "shortDesc": ""
  },
  "strawberrysweet": {
    "name": "Strawberry Sweet",
    "num": 1109,
    "desc": "Evolves Milcery into Alcremie when held and spun around.",
    "shortDesc": ""
  },
  "sunstone": {
    "name": "Sun Stone",
    "num": 80,
    "desc": "Evolves Gloom into Bellossom, Sunkern into Sunflora, Cottonee into Whimsicott, Petilil into Lilligant, and Helioptile into Heliolisk when used.",
    "shortDesc": "Evolves certain species of Pokemon when used."
  },
  "swampertite": {
    "name": "Swampertite",
    "num": 752,
    "desc": "If held by a Swampert, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "sweetapple": {
    "name": "Sweet Apple",
    "num": 1116,
    "desc": "Evolves Applin into Appletun when used.",
    "shortDesc": ""
  },
  "syrupyapple": {
    "name": "Syrupy Apple",
    "num": 2402,
    "desc": "Evolves Applin into Dipplin when used.",
    "shortDesc": ""
  },
  "tamatoberry": {
    "name": "Tamato Berry",
    "num": 174,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "tangaberry": {
    "name": "Tanga Berry",
    "num": 194,
    "desc": "Halves damage taken from a supereffective Bug-type attack. Single use.",
    "shortDesc": ""
  },
  "tapuniumz": {
    "name": "Tapunium Z",
    "num": 801,
    "desc": "If held by a Tapu with Nature's Madness, it can use Guardian of Alola.",
    "shortDesc": ""
  },
  "tartapple": {
    "name": "Tart Apple",
    "num": 1117,
    "desc": "Evolves Applin into Flapple when used.",
    "shortDesc": ""
  },
  "terrainextender": {
    "name": "Terrain Extender",
    "num": 879,
    "desc": "Holder's use of Electric/Grassy/Misty/Psychic Terrain lasts 8 turns instead of 5.",
    "shortDesc": ""
  },
  "thickclub": {
    "name": "Thick Club",
    "num": 258,
    "desc": "If held by a Cubone or a Marowak, its Attack is doubled.",
    "shortDesc": ""
  },
  "throatspray": {
    "name": "Throat Spray",
    "num": 1118,
    "desc": "Raises holder's Special Attack by 1 stage after it uses a sound move. Single use.",
    "shortDesc": ""
  },
  "thunderstone": {
    "name": "Thunder Stone",
    "num": 83,
    "desc": "Evolves Pikachu into Raichu or Alolan Raichu, Eevee into Jolteon, Eelektrik into Eelektross, and Charjabug into Vikavolt when used.",
    "shortDesc": "Evolves certain species of Pokemon when used."
  },
  "timerball": {
    "name": "Timer Ball",
    "num": 10,
    "desc": "A Poke Ball that becomes better the more turns there are in a battle.",
    "shortDesc": ""
  },
  "toxicorb": {
    "name": "Toxic Orb",
    "num": 272,
    "desc": "At the end of every turn, this item attempts to badly poison the holder.",
    "shortDesc": ""
  },
  "toxicplate": {
    "name": "Toxic Plate",
    "num": 304,
    "desc": "Holder's Poison-type attacks have 1.2x power. Judgment is Poison type.",
    "shortDesc": ""
  },
  "tr00": {
    "name": "TR00",
    "num": 1130,
    "desc": "Teaches certain Pokemon the move Swords Dance. One use.",
    "shortDesc": ""
  },
  "tr01": {
    "name": "TR01",
    "num": 1131,
    "desc": "Teaches certain Pokemon the move Body Slam. One use.",
    "shortDesc": ""
  },
  "tr02": {
    "name": "TR02",
    "num": 1132,
    "desc": "Teaches certain Pokemon the move Flamethrower. One use.",
    "shortDesc": ""
  },
  "tr03": {
    "name": "TR03",
    "num": 1133,
    "desc": "Teaches certain Pokemon the move Hydro Pump. One use.",
    "shortDesc": ""
  },
  "tr04": {
    "name": "TR04",
    "num": 1134,
    "desc": "Teaches certain Pokemon the move Surf. One use.",
    "shortDesc": ""
  },
  "tr05": {
    "name": "TR05",
    "num": 1135,
    "desc": "Teaches certain Pokemon the move Ice Beam. One use.",
    "shortDesc": ""
  },
  "tr06": {
    "name": "TR06",
    "num": 1136,
    "desc": "Teaches certain Pokemon the move Blizzard. One use.",
    "shortDesc": ""
  },
  "tr07": {
    "name": "TR07",
    "num": 1137,
    "desc": "Teaches certain Pokemon the move Low Kick. One use.",
    "shortDesc": ""
  },
  "tr08": {
    "name": "TR08",
    "num": 1138,
    "desc": "Teaches certain Pokemon the move Thunderbolt. One use.",
    "shortDesc": ""
  },
  "tr09": {
    "name": "TR09",
    "num": 1139,
    "desc": "Teaches certain Pokemon the move Thunder. One use.",
    "shortDesc": ""
  },
  "tr10": {
    "name": "TR10",
    "num": 1140,
    "desc": "Teaches certain Pokemon the move Earthquake. One use.",
    "shortDesc": ""
  },
  "tr11": {
    "name": "TR11",
    "num": 1141,
    "desc": "Teaches certain Pokemon the move Psychic. One use.",
    "shortDesc": ""
  },
  "tr12": {
    "name": "TR12",
    "num": 1142,
    "desc": "Teaches certain Pokemon the move Agility. One use.",
    "shortDesc": ""
  },
  "tr13": {
    "name": "TR13",
    "num": 1143,
    "desc": "Teaches certain Pokemon the move Focus Energy. One use.",
    "shortDesc": ""
  },
  "tr14": {
    "name": "TR14",
    "num": 1144,
    "desc": "Teaches certain Pokemon the move Metronome. One use.",
    "shortDesc": ""
  },
  "tr15": {
    "name": "TR15",
    "num": 1145,
    "desc": "Teaches certain Pokemon the move Fire Blast. One use.",
    "shortDesc": ""
  },
  "tr16": {
    "name": "TR16",
    "num": 1146,
    "desc": "Teaches certain Pokemon the move Waterfall. One use.",
    "shortDesc": ""
  },
  "tr17": {
    "name": "TR17",
    "num": 1147,
    "desc": "Teaches certain Pokemon the move Amnesia. One use.",
    "shortDesc": ""
  },
  "tr18": {
    "name": "TR18",
    "num": 1148,
    "desc": "Teaches certain Pokemon the move Leech Life. One use.",
    "shortDesc": ""
  },
  "tr19": {
    "name": "TR19",
    "num": 1149,
    "desc": "Teaches certain Pokemon the move Tri Attack. One use.",
    "shortDesc": ""
  },
  "tr20": {
    "name": "TR20",
    "num": 1150,
    "desc": "Teaches certain Pokemon the move Substitute. One use.",
    "shortDesc": ""
  },
  "tr21": {
    "name": "TR21",
    "num": 1151,
    "desc": "Teaches certain Pokemon the move Reversal. One use.",
    "shortDesc": ""
  },
  "tr22": {
    "name": "TR22",
    "num": 1152,
    "desc": "Teaches certain Pokemon the move Sludge Bomb. One use.",
    "shortDesc": ""
  },
  "tr23": {
    "name": "TR23",
    "num": 1153,
    "desc": "Teaches certain Pokemon the move Spikes. One use.",
    "shortDesc": ""
  },
  "tr24": {
    "name": "TR24",
    "num": 1154,
    "desc": "Teaches certain Pokemon the move Outrage. One use.",
    "shortDesc": ""
  },
  "tr25": {
    "name": "TR25",
    "num": 1155,
    "desc": "Teaches certain Pokemon the move Psyshock. One use.",
    "shortDesc": ""
  },
  "tr26": {
    "name": "TR26",
    "num": 1156,
    "desc": "Teaches certain Pokemon the move Endure. One use.",
    "shortDesc": ""
  },
  "tr27": {
    "name": "TR27",
    "num": 1157,
    "desc": "Teaches certain Pokemon the move Sleep Talk. One use.",
    "shortDesc": ""
  },
  "tr28": {
    "name": "TR28",
    "num": 1158,
    "desc": "Teaches certain Pokemon the move Megahorn. One use.",
    "shortDesc": ""
  },
  "tr29": {
    "name": "TR29",
    "num": 1159,
    "desc": "Teaches certain Pokemon the move Baton Pass. One use.",
    "shortDesc": ""
  },
  "tr30": {
    "name": "TR30",
    "num": 1160,
    "desc": "Teaches certain Pokemon the move Encore. One use.",
    "shortDesc": ""
  },
  "tr31": {
    "name": "TR31",
    "num": 1161,
    "desc": "Teaches certain Pokemon the move Iron Tail. One use.",
    "shortDesc": ""
  },
  "tr32": {
    "name": "TR32",
    "num": 1162,
    "desc": "Teaches certain Pokemon the move Crunch. One use.",
    "shortDesc": ""
  },
  "tr33": {
    "name": "TR33",
    "num": 1163,
    "desc": "Teaches certain Pokemon the move Shadow Ball. One use.",
    "shortDesc": ""
  },
  "tr34": {
    "name": "TR34",
    "num": 1164,
    "desc": "Teaches certain Pokemon the move Future Sight. One use.",
    "shortDesc": ""
  },
  "tr35": {
    "name": "TR35",
    "num": 1165,
    "desc": "Teaches certain Pokemon the move Uproar. One use.",
    "shortDesc": ""
  },
  "tr36": {
    "name": "TR36",
    "num": 1166,
    "desc": "Teaches certain Pokemon the move Heat Wave. One use.",
    "shortDesc": ""
  },
  "tr37": {
    "name": "TR37",
    "num": 1167,
    "desc": "Teaches certain Pokemon the move Taunt. One use.",
    "shortDesc": ""
  },
  "tr38": {
    "name": "TR38",
    "num": 1168,
    "desc": "Teaches certain Pokemon the move Trick. One use.",
    "shortDesc": ""
  },
  "tr39": {
    "name": "TR39",
    "num": 1169,
    "desc": "Teaches certain Pokemon the move Superpower. One use.",
    "shortDesc": ""
  },
  "tr40": {
    "name": "TR40",
    "num": 1170,
    "desc": "Teaches certain Pokemon the move Skill Swap. One use.",
    "shortDesc": ""
  },
  "tr41": {
    "name": "TR41",
    "num": 1171,
    "desc": "Teaches certain Pokemon the move Blaze Kick. One use.",
    "shortDesc": ""
  },
  "tr42": {
    "name": "TR42",
    "num": 1172,
    "desc": "Teaches certain Pokemon the move Hyper Voice. One use.",
    "shortDesc": ""
  },
  "tr43": {
    "name": "TR43",
    "num": 1173,
    "desc": "Teaches certain Pokemon the move Overheat. One use.",
    "shortDesc": ""
  },
  "tr44": {
    "name": "TR44",
    "num": 1174,
    "desc": "Teaches certain Pokemon the move Cosmic Power. One use.",
    "shortDesc": ""
  },
  "tr45": {
    "name": "TR45",
    "num": 1175,
    "desc": "Teaches certain Pokemon the move Muddy Water. One use.",
    "shortDesc": ""
  },
  "tr46": {
    "name": "TR46",
    "num": 1176,
    "desc": "Teaches certain Pokemon the move Iron Defense. One use.",
    "shortDesc": ""
  },
  "tr47": {
    "name": "TR47",
    "num": 1177,
    "desc": "Teaches certain Pokemon the move Dragon Claw. One use.",
    "shortDesc": ""
  },
  "tr48": {
    "name": "TR48",
    "num": 1178,
    "desc": "Teaches certain Pokemon the move Bulk Up. One use.",
    "shortDesc": ""
  },
  "tr49": {
    "name": "TR49",
    "num": 1179,
    "desc": "Teaches certain Pokemon the move Calm Mind. One use.",
    "shortDesc": ""
  },
  "tr50": {
    "name": "TR50",
    "num": 1180,
    "desc": "Teaches certain Pokemon the move Leaf Blade. One use.",
    "shortDesc": ""
  },
  "tr51": {
    "name": "TR51",
    "num": 1181,
    "desc": "Teaches certain Pokemon the move Dragon Dance. One use.",
    "shortDesc": ""
  },
  "tr52": {
    "name": "TR52",
    "num": 1182,
    "desc": "Teaches certain Pokemon the move Gyro Ball. One use.",
    "shortDesc": ""
  },
  "tr53": {
    "name": "TR53",
    "num": 1183,
    "desc": "Teaches certain Pokemon the move Close Combat. One use.",
    "shortDesc": ""
  },
  "tr54": {
    "name": "TR54",
    "num": 1184,
    "desc": "Teaches certain Pokemon the move Toxic Spikes. One use.",
    "shortDesc": ""
  },
  "tr55": {
    "name": "TR55",
    "num": 1185,
    "desc": "Teaches certain Pokemon the move Flare Blitz. One use.",
    "shortDesc": ""
  },
  "tr56": {
    "name": "TR56",
    "num": 1186,
    "desc": "Teaches certain Pokemon the move Aura Sphere. One use.",
    "shortDesc": ""
  },
  "tr57": {
    "name": "TR57",
    "num": 1187,
    "desc": "Teaches certain Pokemon the move Poison Jab. One use.",
    "shortDesc": ""
  },
  "tr58": {
    "name": "TR58",
    "num": 1188,
    "desc": "Teaches certain Pokemon the move Dark Pulse. One use.",
    "shortDesc": ""
  },
  "tr59": {
    "name": "TR59",
    "num": 1189,
    "desc": "Teaches certain Pokemon the move Seed Bomb. One use.",
    "shortDesc": ""
  },
  "tr60": {
    "name": "TR60",
    "num": 1190,
    "desc": "Teaches certain Pokemon the move X-Scissor. One use.",
    "shortDesc": ""
  },
  "tr61": {
    "name": "TR61",
    "num": 1191,
    "desc": "Teaches certain Pokemon the move Bug Buzz. One use.",
    "shortDesc": ""
  },
  "tr62": {
    "name": "TR62",
    "num": 1192,
    "desc": "Teaches certain Pokemon the move Dragon Pulse. One use.",
    "shortDesc": ""
  },
  "tr63": {
    "name": "TR63",
    "num": 1193,
    "desc": "Teaches certain Pokemon the move Power Gem. One use.",
    "shortDesc": ""
  },
  "tr64": {
    "name": "TR64",
    "num": 1194,
    "desc": "Teaches certain Pokemon the move Focus Blast. One use.",
    "shortDesc": ""
  },
  "tr65": {
    "name": "TR65",
    "num": 1195,
    "desc": "Teaches certain Pokemon the move Energy Ball. One use.",
    "shortDesc": ""
  },
  "tr66": {
    "name": "TR66",
    "num": 1196,
    "desc": "Teaches certain Pokemon the move Brave Bird. One use.",
    "shortDesc": ""
  },
  "tr67": {
    "name": "TR67",
    "num": 1197,
    "desc": "Teaches certain Pokemon the move Earth Power. One use.",
    "shortDesc": ""
  },
  "tr68": {
    "name": "TR68",
    "num": 1198,
    "desc": "Teaches certain Pokemon the move Nasty Plot. One use.",
    "shortDesc": ""
  },
  "tr69": {
    "name": "TR69",
    "num": 1199,
    "desc": "Teaches certain Pokemon the move Zen Headbutt. One use.",
    "shortDesc": ""
  },
  "tr70": {
    "name": "TR70",
    "num": 1200,
    "desc": "Teaches certain Pokemon the move Flash Cannon. One use.",
    "shortDesc": ""
  },
  "tr71": {
    "name": "TR71",
    "num": 1201,
    "desc": "Teaches certain Pokemon the move Leaf Storm. One use.",
    "shortDesc": ""
  },
  "tr72": {
    "name": "TR72",
    "num": 1202,
    "desc": "Teaches certain Pokemon the move Power Whip. One use.",
    "shortDesc": ""
  },
  "tr73": {
    "name": "TR73",
    "num": 1203,
    "desc": "Teaches certain Pokemon the move Gunk Shot. One use.",
    "shortDesc": ""
  },
  "tr74": {
    "name": "TR74",
    "num": 1204,
    "desc": "Teaches certain Pokemon the move Iron Head. One use.",
    "shortDesc": ""
  },
  "tr75": {
    "name": "TR75",
    "num": 1205,
    "desc": "Teaches certain Pokemon the move Stone Edge. One use.",
    "shortDesc": ""
  },
  "tr76": {
    "name": "TR76",
    "num": 1206,
    "desc": "Teaches certain Pokemon the move Stealth Rock. One use.",
    "shortDesc": ""
  },
  "tr77": {
    "name": "TR77",
    "num": 1207,
    "desc": "Teaches certain Pokemon the move Grass Knot. One use.",
    "shortDesc": ""
  },
  "tr78": {
    "name": "TR78",
    "num": 1208,
    "desc": "Teaches certain Pokemon the move Sludge Wave. One use.",
    "shortDesc": ""
  },
  "tr79": {
    "name": "TR79",
    "num": 1209,
    "desc": "Teaches certain Pokemon the move Heavy Slam. One use.",
    "shortDesc": ""
  },
  "tr80": {
    "name": "TR80",
    "num": 1210,
    "desc": "Teaches certain Pokemon the move Electro Ball. One use.",
    "shortDesc": ""
  },
  "tr81": {
    "name": "TR81",
    "num": 1211,
    "desc": "Teaches certain Pokemon the move Foul Play. One use.",
    "shortDesc": ""
  },
  "tr82": {
    "name": "TR82",
    "num": 1212,
    "desc": "Teaches certain Pokemon the move Stored Power. One use.",
    "shortDesc": ""
  },
  "tr83": {
    "name": "TR83",
    "num": 1213,
    "desc": "Teaches certain Pokemon the move Ally Switch. One use.",
    "shortDesc": ""
  },
  "tr84": {
    "name": "TR84",
    "num": 1214,
    "desc": "Teaches certain Pokemon the move Scald. One use.",
    "shortDesc": ""
  },
  "tr85": {
    "name": "TR85",
    "num": 1215,
    "desc": "Teaches certain Pokemon the move Work Up. One use.",
    "shortDesc": ""
  },
  "tr86": {
    "name": "TR86",
    "num": 1216,
    "desc": "Teaches certain Pokemon the move Wild Charge. One use.",
    "shortDesc": ""
  },
  "tr87": {
    "name": "TR87",
    "num": 1217,
    "desc": "Teaches certain Pokemon the move Drill Run. One use.",
    "shortDesc": ""
  },
  "tr88": {
    "name": "TR88",
    "num": 1218,
    "desc": "Teaches certain Pokemon the move Heat Crash. One use.",
    "shortDesc": ""
  },
  "tr89": {
    "name": "TR89",
    "num": 1219,
    "desc": "Teaches certain Pokemon the move Hurricane. One use.",
    "shortDesc": ""
  },
  "tr90": {
    "name": "TR90",
    "num": 1220,
    "desc": "Teaches certain Pokemon the move Play Rough. One use.",
    "shortDesc": ""
  },
  "tr91": {
    "name": "TR91",
    "num": 1221,
    "desc": "Teaches certain Pokemon the move Venom Drench. One use.",
    "shortDesc": ""
  },
  "tr92": {
    "name": "TR92",
    "num": 1222,
    "desc": "Teaches certain Pokemon the move Dazzling Gleam. One use.",
    "shortDesc": ""
  },
  "tr93": {
    "name": "TR93",
    "num": 1223,
    "desc": "Teaches certain Pokemon the move Darkest Lariat. One use.",
    "shortDesc": ""
  },
  "tr94": {
    "name": "TR94",
    "num": 1224,
    "desc": "Teaches certain Pokemon the move High Horsepower. One use.",
    "shortDesc": ""
  },
  "tr95": {
    "name": "TR95",
    "num": 1225,
    "desc": "Teaches certain Pokemon the move Throat Chop. One use.",
    "shortDesc": ""
  },
  "tr96": {
    "name": "TR96",
    "num": 1226,
    "desc": "Teaches certain Pokemon the move Pollen Puff. One use.",
    "shortDesc": ""
  },
  "tr97": {
    "name": "TR97",
    "num": 1227,
    "desc": "Teaches certain Pokemon the move Psychic Fangs. One use.",
    "shortDesc": ""
  },
  "tr98": {
    "name": "TR98",
    "num": 1228,
    "desc": "Teaches certain Pokemon the move Liquidation. One use.",
    "shortDesc": ""
  },
  "tr99": {
    "name": "TR99",
    "num": 1229,
    "desc": "Teaches certain Pokemon the move Body Press. One use.",
    "shortDesc": ""
  },
  "twistedspoon": {
    "name": "Twisted Spoon",
    "num": 248,
    "desc": "Holder's Psychic-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "tyranitarite": {
    "name": "Tyranitarite",
    "num": 669,
    "desc": "If held by a Tyranitar, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "ultraball": {
    "name": "Ultra Ball",
    "num": 2,
    "desc": "An ultra-performance Ball that provides a higher catch rate than a Great Ball.",
    "shortDesc": ""
  },
  "ultranecroziumz": {
    "name": "Ultranecrozium Z",
    "num": 923,
    "desc": "Dusk Mane/Dawn Wings Necrozma: Ultra Burst, then Z-Move w/ Photon Geyser.",
    "shortDesc": ""
  },
  "unremarkableteacup": {
    "name": "Unremarkable Teacup",
    "num": 2403,
    "desc": "Evolves Poltchageist into Sinistcha when used.",
    "shortDesc": ""
  },
  "upgrade": {
    "name": "Up-Grade",
    "num": 252,
    "desc": "Evolves Porygon into Porygon2 when traded.",
    "shortDesc": ""
  },
  "utilityumbrella": {
    "name": "Utility Umbrella",
    "num": 1123,
    "desc": "The holder ignores rain- and sun-based effects. Damage and accuracy calculations from attacks used by the holder are affected by rain and sun, but not attacks used against the holder.",
    "shortDesc": "The holder ignores rain- and sun-based effects."
  },
  "venusaurite": {
    "name": "Venusaurite",
    "num": 659,
    "desc": "If held by a Venusaur, this item allows it to Mega Evolve in battle.",
    "shortDesc": ""
  },
  "wacanberry": {
    "name": "Wacan Berry",
    "num": 186,
    "desc": "Halves damage taken from a supereffective Electric-type attack. Single use.",
    "shortDesc": ""
  },
  "watergem": {
    "name": "Water Gem",
    "num": 549,
    "desc": "Holder's first successful Water-type attack will have 1.3x power. Single use.",
    "shortDesc": ""
  },
  "watermemory": {
    "name": "Water Memory",
    "num": 913,
    "desc": "Holder's Multi-Attack is Water type.",
    "shortDesc": ""
  },
  "waterstone": {
    "name": "Water Stone",
    "num": 84,
    "desc": "Evolves Poliwhirl into Poliwrath, Shellder into Cloyster, Staryu into Starmie, Eevee into Vaporeon, Lombre into Ludicolo, and Panpour into Simipour when used.",
    "shortDesc": "Evolves certain species of Pokemon when used."
  },
  "wateriumz": {
    "name": "Waterium Z",
    "num": 778,
    "desc": "If holder has a Water move, this item allows it to use a Water Z-Move.",
    "shortDesc": ""
  },
  "watmelberry": {
    "name": "Watmel Berry",
    "num": 181,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "waveincense": {
    "name": "Wave Incense",
    "num": 317,
    "desc": "Holder's Water-type attacks have 1.2x power.",
    "shortDesc": ""
  },
  "weaknesspolicy": {
    "name": "Weakness Policy",
    "num": 639,
    "desc": "If holder is hit super effectively, raises Attack, Sp. Atk by 2 stages. Single use.",
    "shortDesc": ""
  },
  "wellspringmask": {
    "name": "Wellspring Mask",
    "num": 2407,
    "desc": "Ogerpon-Wellspring: 1.2x power attacks; Terastallize to gain Embody Aspect.",
    "shortDesc": ""
  },
  "wepearberry": {
    "name": "Wepear Berry",
    "num": 167,
    "desc": "Cannot be eaten by the holder. No effect when eaten with Bug Bite or Pluck.",
    "shortDesc": ""
  },
  "whippeddream": {
    "name": "Whipped Dream",
    "num": 646,
    "desc": "Evolves Swirlix into Slurpuff when traded.",
    "shortDesc": ""
  },
  "whiteherb": {
    "name": "White Herb",
    "num": 214,
    "desc": "Restores all lowered stat stages to 0 when one is less than 0. Single use.",
    "shortDesc": ""
  },
  "widelens": {
    "name": "Wide Lens",
    "num": 265,
    "desc": "The accuracy of attacks by the holder is 1.1x.",
    "shortDesc": ""
  },
  "wikiberry": {
    "name": "Wiki Berry",
    "num": 160,
    "desc": "Restores 1/3 max HP at 1/4 max HP or less; confuses if -SpA Nature. Single use.",
    "shortDesc": ""
  },
  "wiseglasses": {
    "name": "Wise Glasses",
    "num": 267,
    "desc": "Holder's special attacks have 1.1x power.",
    "shortDesc": ""
  },
  "yacheberry": {
    "name": "Yache Berry",
    "num": 188,
    "desc": "Halves damage taken from a supereffective Ice-type attack. Single use.",
    "shortDesc": ""
  },
  "zapplate": {
    "name": "Zap Plate",
    "num": 300,
    "desc": "Holder's Electric-type attacks have 1.2x power. Judgment is Electric type.",
    "shortDesc": ""
  },
  "zoomlens": {
    "name": "Zoom Lens",
    "num": 276,
    "desc": "The accuracy of attacks by the holder is 1.2x if it moves after its target.",
    "shortDesc": ""
  },
  "berserkgene": {
    "name": "Berserk Gene",
    "num": 0,
    "desc": "(Gen 2) On switch-in, raises holder's Attack by 2 and confuses it. Single use.",
    "shortDesc": ""
  },
  "berry": {
    "name": "Berry",
    "num": 155,
    "desc": "(Gen 2) Restores 10 HP when at 1/2 max HP or less. Single use.",
    "shortDesc": ""
  },
  "bitterberry": {
    "name": "Bitter Berry",
    "num": 156,
    "desc": "(Gen 2) Holder is cured if it is confused. Single use.",
    "shortDesc": ""
  },
  "burntberry": {
    "name": "Burnt Berry",
    "num": 153,
    "desc": "(Gen 2) Holder is cured if it is frozen. Single use.",
    "shortDesc": ""
  },
  "goldberry": {
    "name": "Gold Berry",
    "num": 158,
    "desc": "(Gen 2) Restores 30 HP when at 1/2 max HP or less. Single use.",
    "shortDesc": ""
  },
  "iceberry": {
    "name": "Ice Berry",
    "num": 152,
    "desc": "(Gen 2) Holder is cured if it is burned. Single use.",
    "shortDesc": ""
  },
  "mintberry": {
    "name": "Mint Berry",
    "num": 150,
    "desc": "(Gen 2) Holder wakes up if it is asleep. Single use.",
    "shortDesc": ""
  },
  "miracleberry": {
    "name": "Miracle Berry",
    "num": 157,
    "desc": "(Gen 2) Holder cures itself if it is confused or has a status condition. Single use.",
    "shortDesc": ""
  },
  "mysteryberry": {
    "name": "Mystery Berry",
    "num": 154,
    "desc": "(Gen 2) Restores 5 PP to the first of the holder's moves to reach 0 PP. Single use.",
    "shortDesc": ""
  },
  "pinkbow": {
    "name": "Pink Bow",
    "num": 251,
    "desc": "(Gen 2) Holder's Normal-type attacks have 1.1x power.",
    "shortDesc": ""
  },
  "polkadotbow": {
    "name": "Polkadot Bow",
    "num": 251,
    "desc": "(Gen 2) Holder's Normal-type attacks have 1.1x power.",
    "shortDesc": ""
  },
  "przcureberry": {
    "name": "PRZ Cure Berry",
    "num": 149,
    "desc": "(Gen 2) Holder cures itself if it is paralyzed. Single use.",
    "shortDesc": ""
  },
  "psncureberry": {
    "name": "PSN Cure Berry",
    "num": 151,
    "desc": "(Gen 2) Holder is cured if it is poisoned. Single use.",
    "shortDesc": ""
  }
}